/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Visit_PayInputs */

const en_price_page_visit_pay = /** @type {(inputs: Price_Page_Visit_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay online or on the day, as the specialist sets`)
};

const pl_price_page_visit_pay = /** @type {(inputs: Price_Page_Visit_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatność online albo na miejscu, jak ustawi specjalista`)
};

/**
* | output |
* | --- |
* | "Pay online or on the day, as the specialist sets" |
*
* @param {Price_Page_Visit_PayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_visit_pay = /** @type {((inputs?: Price_Page_Visit_PayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Visit_PayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_visit_pay(inputs)
	return en_price_page_visit_pay(inputs)
});